// extracted by mini-css-extract-plugin
module.exports = {"Languages":"Languages_Languages__29tXf","Icon":"Languages_Icon__1SciQ","LanguagesSelect":"Languages_LanguagesSelect__3yyDr","minimalist":"Languages_minimalist__1xOaV"};